import { booleanAttribute, ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { CoopComponent } from 'src/app/components/diagnosis-result/coop/coop.component';
import { InternComponent } from 'src/app/components/diagnosis-result/intern/intern.component';
import { LanguageschoolComponent } from 'src/app/components/diagnosis-result/languageschool/languageschool.component';
import { UniversitiesComponent } from 'src/app/components/diagnosis-result/universities/universities.component';
import { VolunteerComponent } from 'src/app/components/diagnosis-result/volunteer/volunteer.component';
import { WorkingholidayComponent } from 'src/app/components/diagnosis-result/workingholiday/workingholiday.component';
import { LpConsultingReservationComponent } from 'src/app/components/lp-consulting-reservation/lp-consulting-reservation.component';

@Component({
  selector: 'app-diagnosis-result',
  imports: [
    LanguageschoolComponent,
    WorkingholidayComponent,
    InternComponent,
    CoopComponent,
    VolunteerComponent,
    UniversitiesComponent,
    LpConsultingReservationComponent
  ],
  templateUrl: './diagnosis-result.component.html',
  styleUrl: './diagnosis-result.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiagnosisResultComponent {
  readonly completeUrl = input.required<string>();
  readonly lpType = input.required<string>();
  readonly hideRecommend = input(false, { transform: booleanAttribute });

  readonly type = signal<number>(0);

  constructor() {
    const params = new URLSearchParams(window.location.search);
    const type = Number(params.get('type') ?? -1);
    this.type.set(type + 1);
    effect(() => {
      const lpType = this.lpType();
      if (!lpType) {
        return;
      }
      const value = JSON.parse(sessionStorage.getItem('counseling') ?? '{}');
      value.lpType = this.lpType();
      sessionStorage.setItem('counseling', JSON.stringify(value));
    });
  }
}
